import { useEffect } from 'react';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { useAuth } from '../auth/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Dashboard
          </Typography>
          <Typography variant="body1" color="text.secondary" gutterBottom align="center">
            Sign in to access your API key and documentation
          </Typography>

          {error && (
            <Typography color="error" sx={{ mt: 2, mb: 2 }} align="center">
              {error === 'token_exchange_failed'
                ? 'Failed to sign in. Please try again.'
                : 'An error occurred during sign in.'}
            </Typography>
          )}

          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              onClick={login}
            >
              Sign In
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
